module.exports = __webpack_public_path__ + "img/accelerograph.dcd89830.png";